import React, { useState, useEffect, useRef } from 'react'
import './Header.css'
import { BsSearch } from 'react-icons/bs'
import { BiChevronDown } from 'react-icons/bi'
import { Link, Redirect, useLocation } from 'react-router-dom'
import Axios from 'axios'
import { IoStar } from 'react-icons/io5'
import logo from '../logo.png'
import { CheckUserLogin } from '../sessions/CheckUserLoggin'
import { API_URL } from '../config'

const url = `${API_URL}/apps/kscanner`
export default function Header() {
  const rootUrl = window.location.origin
  if (rootUrl !== API_URL && rootUrl !== 'http://localhost:3000') {
    console.log('rootUrl: ' + rootUrl)
    CheckUserLogin()
  }

  const location = useLocation()
  const pathSegments = location.pathname.split('/').filter(Boolean)
  const lastSegment = pathSegments[pathSegments.length - 1]

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [accountName, setAccountName] = useState('')
  const [accountType, setAccountType] = useState('')
  const dropdownRef = useRef()
  const [search, setSearch] = useState('')
  const [queryResults, setQueryResults] = useState([])
  const [open, setOpen] = useState(true)
  const [openLogo, setOpenLogo] = useState(false)
  const [arrowIcon, setArrowIcon] = useState(true)
  const [customername, setCustomername] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [searchBox, setSearchBox] = useState(false)

  const account_type = localStorage.getItem('accounttype') || 'guest'
  const account_name =
    localStorage.getItem('partnername') ||
    localStorage.getItem('businessname') ||
    localStorage.getItem('customername') ||
    'Guest'

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    accountDetails()
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const accountDetails = () => {
    Axios.get(`${url}/webservices.php?query=ACCOUNT-DETAILS`, {
      withCredentials: true,
    })
      .then((response) => {
        setAccountName(response.data.accountName)
        setAccountType(response.data.accountType)
        console.log('Account Details:', response.data)
      })
      .catch((error) => {
        console.error('Error fetching account details:', error)
      })
  }

  const handleLogout = async () => {
    try {
      await fetch(`${url}/logout.php`, {
        method: 'GET',
        credentials: 'include', // sends cookies like sessionId
      })

      // Clear local data and redirect
      localStorage.clear()
      window.location.href = '/login'
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  const handleSearch = async (event) => {
    const searchVal = event.target.value
    setSearch(searchVal)

    const formData = new FormData()
    formData.append('search', searchVal)

    try {
      const response = await Axios.get(
        `${url}/webservices.php?query=SEARCHEVENTS&search=${searchVal}`,
        { withCredentials: true }
      )

      if (response.data.val === 0) {
        setQueryResults([])
      } else {
        setQueryResults(response.data)
      }

      if (!searchVal) {
        setOpen(true)
        setOpenLogo(false)
        setArrowIcon(true)
      } else {
        setOpen(false)
        setOpenLogo(true)
        setArrowIcon(false)
      }
    } catch (error) {
      console.error('Search request failed:', error)
    }
  }

  const style = open ? { display: 'none' } : {}
  const logoStyle = openLogo ? { display: 'none' } : {}
  const arrowIconStyle = arrowIcon ? { display: 'none' } : {}

  const date = new Date()
  const day = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  const fulldate = year + '-' + month + '-' + day
  let event = ''

  const accountId = localStorage.getItem('customerid')

  return (
    <header className="top-header">
      <Link
        className={
          account_type !== 'guest' && account_type !== 'customer'
            ? 'd-none'
            : 'd-none d-sm-block d-md-block'
        }
        to={
          account_type === 'customer' ? '/customerdashboard' : account_type === 'guest' ? '/' : ''
        }
      >
        <span className="float-left mb-0 text-left mr-3">
          <img src={logo} width={40} />
        </span>
      </Link>
      <div className="header-right">
        {account_type !== 'partner' && (
          <div className={'search-box'}>
            <span className="search-icon">
              <BsSearch size={17} />
            </span>
            <input
              type="text"
              placeholder="Search events..."
              value={search}
              onChange={handleSearch}
              autoComplete="off"
            />
            <div className="w-100 response textMedium search-results" style={style}>
              {queryResults.length < 1 ? (
                <div className="no-match-found">
                  {accountType.toLocaleLowerCase() === 'business'
                    ? 'No results. Make sure your account has events.'
                    : 'No event found'}
                </div>
              ) : (
                queryResults.map((item, index) => {
                  const posterUri = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`
                  if (item.indexid >= 1) {
                    return ''
                  } else {
                    return (
                      <div className="row" key={index}>
                        <div className="col-12 default-padding" key={index}>
                          <div className="row">
                            <Link
                              to={{
                                pathname:
                                  accountType.toLocaleLowerCase() === 'business'
                                    ? '/editevent'
                                    : `/event/${item.eventid}/tickets`,

                                state: {
                                  is_sponsorship: item.is_sponsorship,
                                  campaignStatus: item.campaignStatus ?? 'stop',
                                  fromHome: true,
                                  eventid: item.eventid,
                                  eventDate: item.event_day,
                                  event_date: item.event_day,
                                  enddate: item.finish_day,
                                  finish_date: item.finish_day,
                                  theme: event.theme,
                                  expectednum: event.expected,
                                  time: item.start_time,
                                  starttime: item.start_time,
                                  fulldate: fulldate,
                                  customerid: accountId,
                                  posterUri: posterUri,
                                  accountid: accountId,
                                  accounttype: accountType,
                                  customername: customername,
                                  email: email,
                                  phone: phone,
                                  venue: item.event_location,
                                  description: item.event_des,
                                  businessid: item.businessid,
                                  poster: item.poster,
                                  eventname: item.eventname,
                                  eventday: item.eventday,
                                  starttime: item.start_time,
                                  endtime: item.finish_time,
                                  previousPage: window.location.pathname.replace(/\\|\//g, ''),
                                  category: '',
                                },
                              }}
                              className="eventLinks links-width"
                            >
                              <div className="search-results-inner">
                                {/* <div className="search-container mr-2">
                                <BsSearch />
                              </div> */}
                                <div className="results-container align-self-center text-left line-height-17 cursor-pointer text-underline-none">
                                  <span>
                                    {item.event_name.length > 27
                                      ? (event = item.event_name.substr(0, 27) + '...')
                                      : (event = item.event_name)}
                                  </span>{' '}
                                  <span>
                                    {item.is_sponsorship == 1 ? (
                                      <label className="sponsored-badge-dashboard mb-0 mt-0">
                                        <IoStar size={15} /> &nbsp;
                                      </label>
                                    ) : (
                                      ''
                                    )}
                                  </span>
                                  <br />
                                  <label
                                    className={
                                      accountType.toLocaleLowerCase() === 'business'
                                        ? 'd-none'
                                        : 'mb-0 w-100 cursor-pointer text-underline-none'
                                    }
                                  >
                                    {item.businessname.length > 30 ? (
                                      <span className="businessname">
                                        <span className="text-black font-normal">Host:</span>{' '}
                                        {item.businessname.substr(0, 30)}
                                        ...
                                      </span>
                                    ) : (
                                      <span className="businessname">
                                        <span className="text-black font-normal">Host:</span>{' '}
                                        {item.businessname}
                                      </span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )
                  }
                })
              )}
            </div>
          </div>
        )}
        <div
          className={account_type === 'guest' ? '' : 'account-menu d-none d-sm-block d-md-block'}
          ref={dropdownRef}
          onClick={toggleDropdown}
        >
          <span className="account-name">
            <label className="mb-0 w-100 line-height-15 font-normal cursor-pointer text-underline-none">
              <label className="mb-0 cursor-pointer">
                {account_name.length > 20 ? account_name.slice(0, 20) + '...' : account_name}
                <BiChevronDown size={25} />
              </label>
              <br />
              <span className="mb-0 text-grey text-13 w-100 font-normal">
                {/* <span className="text-black font-normal">Account:</span>{" "} */}
                {account_type === 'business'
                  ? 'Organizer'
                  : account_type === 'customer'
                  ? 'Attendee'
                  : account_type === 'guest'
                  ? ''
                  : 'Affiliate'}
              </span>
            </label>
          </span>
          {dropdownOpen && (
            <ul className="dropdown_">
              <Link
                to={{
                  pathname:
                    account_type === 'business'
                      ? '/dashboard'
                      : account_type === 'customer'
                      ? '/customerdashboard'
                      : '/in',
                }}
                className={account_type !== 'guest' ? 'text-underline-none text-black' : 'd-none'}
              >
                <li>Dashboard</li>
              </Link>

              <Link
                to={account_type === 'guest' ? '/login' : '/profile'}
                className="text-underline-none text-black"
              >
                <li>{account_type === 'guest' ? 'Log In' : 'My Account'}</li>
              </Link>
              <Link
                to={{
                  pathname: account_type === 'guest' ? '/registration' : '/changepassword',
                  state: {
                    credentials: 'password',
                  },
                }}
                className="text-underline-none text-black"
              >
                <li>{account_type === 'guest' ? 'Create Account' : 'Change Password'}</li>
              </Link>
              <li className={account_type !== 'guest' ? '' : 'd-none'} onClick={handleLogout}>
                Logout
              </li>

              <Link
                to={{
                  pathname: account_type === 'guest' ? '/aboutkaramale' : '/changepassword',
                  state: {
                    credentials: 'password',
                  },
                }}
                className={account_type === 'guest' ? 'text-underline-none text-black' : 'd-none'}
              >
                <li>{account_type === 'guest' ? 'About Karamale' : ''}</li>
              </Link>

              <Link
                to={{
                  pathname: '/fees',
                }}
                className={account_type === 'guest' ? 'text-underline-none text-black' : 'd-none'}
              >
                <li>Pricing</li>
              </Link>
              <Link
                to={{
                  pathname: '/budget',
                }}
                className={account_type === 'guest' ? 'text-underline-none text-black' : 'd-none'}
              >
                <li>Calculate</li>
              </Link>

              <Link
                to={{
                  pathname: '/aboutsalesparnter',
                }}
                className={account_type === 'guest' ? 'text-underline-none text-black' : 'd-none'}
              >
                <li>Affiliate Program</li>
              </Link>
            </ul>
          )}
        </div>
      </div>
    </header>
  )
}
